// extracted by mini-css-extract-plugin
export default {"root":"v7QsJY"};